import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      light: '#181818',
      main: '#EE1520',
      dark: '#121212',
      contrastText: '#fff',
    },

  },
});

export default theme;
